module.exports = __webpack_public_path__ + "img/posts.10f5e012.svg";